module.exports = __webpack_public_path__ + "static/media/Lock.80dc6abb.svg";